module.exports = __webpack_public_path__ + "static/josaa-3bef714d975c8bd77b670232809c9461.svg";